/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Help_Rolespermissionstable3Inputs */

const en_usermanagement_help_rolespermissionstable3 = /** @type {(inputs: Usermanagement_Help_Rolespermissionstable3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Roles - Permissions table`)
};

/**
* | output |
* | --- |
* | "User Roles - Permissions table" |
*
* @param {Usermanagement_Help_Rolespermissionstable3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_help_rolespermissionstable3 = /** @type {((inputs?: Usermanagement_Help_Rolespermissionstable3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Help_Rolespermissionstable3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_help_rolespermissionstable3(inputs)
});
export { usermanagement_help_rolespermissionstable3 as "userManagement_help_rolesPermissionsTable" }